import { Paper, Typography, TextField, Alert, Grid } from '@mui/material'
import type { PRSheet } from '../../../types/salesforce'
import { ImageUploadField } from './ImageUploadField'

export interface AboutMeSectionProps {
  prSheet: PRSheet
  onChange: (field: keyof PRSheet, value: string) => void
  onBlur?: () => void
  linkedEntityId?: string
}

export function AboutMeSection({ prSheet, onChange, onBlur, linkedEntityId }: AboutMeSectionProps) {
  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        👋 About Me
      </Typography>

      <Grid container spacing={3}>
        {/* 左列: プロフィール画像 */}
        <Grid size={{ xs: 12, md: 3 }}>
          <ImageUploadField
            label="プロフィール画像"
            imageContentDocumentId={prSheet.ProfileImageContentDocumentId__c}
            onImageUpload={(contentDocumentId) => onChange('ProfileImageContentDocumentId__c', contentDocumentId)}
            onImageDelete={() => onChange('ProfileImageContentDocumentId__c', '')}
            onBlur={onBlur}
            circular={true}
            linkedEntityId={linkedEntityId}
          />
        </Grid>

        {/* 右列: キャッチコピー + Jobs */}
        <Grid size={{ xs: 12, md: 9 }}>
          <Alert severity="info" icon={<span>💡</span>} sx={{ mt: 2, mb: 2 }}>
            これまでの取り組みを書き出してから自分がどんな人物なのかが伝わるキャッチコピーを考えましょう！自己紹介の最初に自分が「＊＊＊な人間です」となる"＊＊＊"の部分をイメージしてください。
          </Alert>

          {/* キャッチコピー */}
          <TextField
            label="💫 キャッチコピー（28文字以内）"
            fullWidth
            margin="normal"
            value={prSheet.Catchphrase__c || ''}
            onChange={(e) => onChange('Catchphrase__c', e.target.value)}
            onBlur={onBlur}
            slotProps={{ htmlInput: { maxLength: 28 } }}
            helperText={`${(prSheet.Catchphrase__c || '').length} / 28文字`}
          />

          {/* Jobs */}
          <TextField
            label="🧳 Jobs"
            fullWidth
            margin="normal"
            multiline
            rows={3}
            value={prSheet.Jobs__c || ''}
            onChange={(e) => onChange('Jobs__c', e.target.value)}
            onBlur={onBlur}
          />
        </Grid>
      </Grid>
    </Paper>
  )
}
